import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <div className="mx-auto w-full max-w-[860px] px-7 pt-14">
      <p className="hud-label mb-3.5">404</p>
      <h1 className="font-display text-2xl font-black tracking-[0.04em] text-red uppercase">Signal lost</h1>
      <p className="mt-2 text-muted">
        Nothing lives at this address.{' '}
        <Link to="/" className="text-cyan underline">
          Back to the studio
        </Link>
        .
      </p>
    </div>
  );
}
